import React, { useEffect } from "react";
import classes from "../../style/Style.module.css";
import { useNavigate } from "react-router-dom";
import LottieAnimation2 from "../../Components/Animation/LottieAnimation2";

import DexterCall from "../../Images/UpdatedDexter-call.svg";

const DextersScanning5 = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      navigate("/dexterr-confirm-residential-status");
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [navigate]);

  return (
    <div className={classes.DextersScanning_Main_Container2}>
      <div className={classes.KYC_Header}>


        {/* <div className={classes.Dexter_Explainer_Container}>
          <img alt="" src={DexterCall} />
          <span className={classes.Dexter_Call_text}>Dexterr Explains</span>
        </div> */}
      </div>

      <div className={classes.LottiePlayer_Container2}>
        <LottieAnimation2 />
      </div>
      <div className={classes.Dexteranimation2_text}>
        Redirecting to Payment Gateway
      </div>

    </div>
  );
};

export default DextersScanning5;
